/* eslint-disable @next/next/no-img-element */
// libraries
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados } from '../../../services/selectors';
import { formatCaracteristicas, formatSelects, formatSelectsTransacao, isColorLight, removerAcentos } from '../../../utils/FunctionsGlobals';
import { useAuth } from '../../context/Info';
import DrawerComponent from '../../drawer/DrawerComponent';
import Mocks from './WelcomePieces.mocks';
import styles from './WelcomePieces.module.css';
const Select = dynamic(() => import('react-select'), { ssr: false });

// interface
interface ISelectors {
    allCities: Array<{ label: string; value: string; id_estado: any }>;
    allTypes: any;
    allTransacao: Array<{ label: string; value: string }>;
    allCompany: Array<{ label: string; value: string }>;
    site: any;
    companyInputActual: any;
    setCompanyInputActual: any;
    setActiveDrawer: any;
    activeDrawer: any;
    origin?: any;
    codsite?: any;
    favorito: Array<number>;
    valores?: any;
    codsite2?: any;
    isMobile1?: Boolean;
    props: any;
    allCards: any;
}

type Banner = {
  ativo: boolean;
  titulo: string;
  url: string;
  url_link: string | null;
  message: string;
};

const WelcomePieces: React.FC<ISelectors> = ({
    allCities,
    allTypes,
    allCompany,
    allTransacao,
    site,
    companyInputActual,
    setCompanyInputActual,
    setActiveDrawer,
    activeDrawer,
    origin,
    codsite,
    favorito,
    valores,
    codsite2,
    isMobile1,
    props,
    allCards
}) => {
    // constants
    const {
        listCategory,
        setListCategory,
        listEstados,
        setListEstados,
        listCaracteristicas,
        setListCaracteristicas,
        listDatas,
        allDataHome,
        setListDatas
    } = useAuth();
    
    // Carousel state for banners
    const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
    const banners: Array<Pick<Banner, "url" | "url_link" | "message">> =
    (allDataHome?.allBanners ?? [])
        .filter((b: Banner) => b?.ativo && b?.titulo === "topo" && b?.url)
        .map(({ url, url_link, message }) => ({ url, url_link, message }));
    // .slice(0, 3) // <- se quiser no máximo 3
    const cor_font = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    const allOptions = [{label: '1', value: 1},{label: '2', value: 2},{label: '3', value: 3},{label: '4', value: 4},{label: '5 +', value: 5}];
    const [allDistrict, setAllDistrict] = useState([]);
    const [allCitiesAux, setAllCitiesAux] = useState(site?.id == 2177 ? allCities.filter(city => city?.id_estado == 24) : allCities);
    const [searchAdvanced, setSearchAdvanced] = useState<boolean>(site?.id == "2023" || site?.id == "1667" || site?.id == "2366" || site?.id == "2118" || site?.id == "2148" || site?.id == "278" ? true : false);
    const [citiesActual, setCitiesActual] = useState<any>(null);
    const [districtActual, setDistrictActual] = useState<Array<{label: string, value: number}>>([]);
    const [typesActual, setTypesActual] = useState<Array<{label: string, value: number}>>([]);
    const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
    const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
    const [categoryActual, setCategoryActual] = useState<any>([]);
    const [estadoActual, setEstadoActual] = useState<any>(site?.id == 2177 ? {label: 'Rio Grande do Sul', value: 23} : {value: 0});
    const [urlTipo, setUrlTipo] = useState<string>("");
    const [urlCaract, setUrlCaract] = useState<string>("");
    const [urlDatas, setUrlDatas] = useState<string>("");
    const [urlDistrict, setUrlDistrict] = useState<string>("");
    const [transacaoActual, setTransacaoActual] = useState<any>(allTransacao[0]);
    const [dormitoriosActual, setDormitoriosAtual] = useState<any>();
    const [banheirosActual, setBanheirosAtual] = useState<any>();
    const [suitesActual, setSuitesAtual] = useState<any>();
    const [vagasActual, setVagasAtual] = useState<any>();
    const [codeActual, setCodeActual] = useState('');
    const [companyActual, setCompanyActual] = useState<any>(null);
    const [buscaAvan, setBuscaAvan] = useState<boolean>(false);
        // novos estados

    const newFilter = () => {
        if (transacaoActual?.value) {
            if (transacaoActual.value.toLowerCase() === 'aluguel') {
                return valores?.precos_locacao[0];
            }
            if (transacaoActual.value.toLowerCase() === 'venda') {
                return valores?.precos_venda[0];
            }
        } else {
            if (allTransacao[0]?.value.toLowerCase() === 'aluguel') {
                return valores?.precos_locacao[0];
            }
            if (allTransacao[0]?.value.toLowerCase() === 'venda') {
                return valores?.precos_venda[0];
            }
        }
        if(valores?.precos_venda[0]?.max > 0){
            return valores?.precos_venda[0];
        }else{
            return valores?.precos_locacao[0];
        }
    };
    const getFiltersPricess = newFilter();
    const [filterPrice, setFilterPrice] = useState<any>(!getFiltersPricess?.min && !getFiltersPricess?.max ? { min: 0, max: 0 } : getFiltersPricess);
    const [value2, setValue2] = React.useState<number[]>([getFiltersPricess?.min , getFiltersPricess?.max]);
    const [minPrice, setMinPrice] = useState<number>(0);
    const [maxPrice, setMaxPrice] = useState<number>(0);

    // atualiza min/max quando muda o perfil (aluguel x venda)
    useEffect(() => {
        const next = newFilter();
        if (!next) return;

        // mantém o filterPrice (se você ainda usa em outros lugares)
        if (filterPrice.min !== next.min || filterPrice.max !== next.max) {
            setFilterPrice(next);
        }
    }, [allTransacao, transacaoActual]);

    // handlers com clamp (mínimo não pode passar do máximo e vice-versa)
    const onMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = Number(e.target.value || 0);
    setMinPrice(v);
    setBuscaAvan(true);
    };

    const onMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = Number(e.target.value || 0);
    setMaxPrice(v < minPrice ? minPrice : v);
    setBuscaAvan(true);
    };

    // methods
    const safeSegment = (value?: string) => {
        return value && value.trim() !== "" ? removerAcentos(value.replaceAll("-", "002D")) : "";
    };

    const renderPath = () => {
        const parts = [
            "imoveis",
            transacaoActual?.value?.toLowerCase() || allTransacao[0]?.value?.toLowerCase() || "venda",
            safeSegment(citiesActual?.label) || "-",
            safeSegment(urlDistrict) || "-",
            safeSegment(companyActual?.label) || "-",
            safeSegment(urlTipo) || "-"
        ];

        if (codeActual) {
            parts.push(codeActual.replaceAll(" ", "%20"));
        }

        let newPath = "/" + parts.join("/");

        if (buscaAvan || site?.id == 2177) {
            const queryParams = new URLSearchParams({
            id_estado: estadoActual?.value,
            min: minPrice.toString(),
            max: maxPrice.toString(),
            data_entrega: urlDatas || "",
            categoria: categoryActual?.value || "",
            dormitorios: dormitoriosActual?.value || "0",
            banheiros: banheirosActual?.value || "0",
            suites: suitesActual?.value || "0",
            vagas: vagasActual?.value || "0",
            id_caracteristica: urlCaract || ""
            });
            newPath += `?${queryParams.toString()}`;
        }

        return newPath.toLowerCase();
    };
    const onChangeCity = async (txt: any) => {
        if(citiesActual == txt)
            setCitiesActual(null);
        else{
            setCitiesActual(txt);
            const infoDistrict = await district(txt.value, origin, codsite);
            setAllDistrict(formatSelects(infoDistrict?.bairros));
            setDistrictActual([])
        }
    };
    const onChangeDistrict = (txt: any) => {
        setUrlDistrict(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setDistrictActual(txt);
    };
    const onChangeCompany = (txt: any) => {
        setCompanyActual(txt);
    };
    const onChangeTypes = (txt: any) => {
        setUrlTipo(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setTypesActual(txt);
    };
    const onChangeCategory = (txt: any) => {
        if(categoryActual == txt)
            setCategoryActual([]);
        else
        setCategoryActual(txt);

        setBuscaAvan(true);
    };
    const onChangeEstado = async (txt: any) => {
        if(estadoActual == txt)
            setEstadoActual(null);
        else{
            // selecionou um novo estado
            setEstadoActual(txt);

            // filtra apenas as cidades que batem com o id_estado
            const cidadesFiltradas = allCities.filter(
                city => city?.id_estado === txt.value
            );

            setCitiesActual(null);
            setDistrictActual([])
            setAllCitiesAux(cidadesFiltradas);
        }
    };
    const onChangeDataEntrega = (txt: any) => {
        setUrlDatas(txt?.map((tip: any) => {return tip?.value}).join(","))
        setDataEntregaActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onChangeCaracteristicas = (txt: any) => {
        setUrlCaract(txt?.map((tip: any) => {return tip?.value}).join(","))
        setCaractActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };
    const onChangeTransacao = (txt: any) => {
        setTransacaoActual(txt);
    };
    const onChangeDormitorios = (txt: any) => {
        setDormitoriosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeBanheiros = (txt: any) => {
        setBanheirosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeSuites = (txt: any) => {
        setSuitesAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeVagas = (txt: any) => {
        setVagasAtual(txt);
        setBuscaAvan(true);
    };

    const onChangeCode = (txt: React.ChangeEvent<HTMLInputElement>) => {
        setCodeActual(txt.target.value);
    };

    const GetInitialFilters = async () => {
        if(listEstados == 0 && site?.id == 2177){
            const getCondo: any = JSON.parse(localStorage.getItem('listEstados') || '[]');

            if(getCondo?.length > 0){
                setListEstados(getCondo);
            } else {
                const infoEstados = await get_estados(origin, codsite);
                const formatEstados = await formatSelects(infoEstados?.estados);
                if(formatEstados?.length > 0){
                    localStorage.setItem('listEstados', JSON.stringify(formatEstados));
                    setListEstados(formatEstados);
                }
                else
                setListEstados([]);
            }
        }

        if(listCategory == 0 && site?.categoria_home){
            const getCondo: any = JSON.parse(localStorage.getItem('listCategory1') || '[]');

            if(getCondo?.length > 0){
                setListCategory(getCondo);
            } else {
                const infoCategory = await categorias(origin, codsite);
                const formatCategorias = await formatSelects(infoCategory?.categorias);
                if(formatCategorias?.length > 0){
                    localStorage.setItem('listCategory1', JSON.stringify(formatCategorias));
                    setListCategory(formatCategorias);
                }
                else
                    setListCategory([]);
            }
        }

        if(listCaracteristicas == 0 && site?.caracteristicas_home){
            const getCondo: any = JSON.parse(localStorage.getItem('listCaracteristicas') || '[]');

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite);
                const formatCarac = await formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);
                    localStorage.setItem('listCaracteristicas', JSON.stringify(formatCarac));
                }
                else
                setListCaracteristicas([]);
            }
        }

        if(listDatas == 0 && site?.mostrar_data_entrega){
            const getCondo: any = JSON.parse(localStorage.getItem('listDatas') || '[]');

            if(getCondo?.length > 0){
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                getCondo.unshift(newItem);
                setListDatas(getCondo);
            } else {
                const infoDatas= await allDatasEntrega(origin, codsite);
                const formatDatas = await formatSelectsTransacao(infoDatas?.datas_entrega);

                if(formatDatas?.length > 0){
                    const newItem = { "label": "Imóvel Pronto", "value": 1 };

                    // Adiciona o novo item no início do array
                    formatDatas.unshift(newItem);
                    setListDatas(formatDatas);
                    localStorage.setItem('formatDatas', JSON.stringify(formatDatas));
                }
                else
                setListDatas([]);
            }
        }
    }

    // Carousel auto-rotation
    useEffect(() => {
        if (banners.length > 1) {
            const interval = setInterval(() => {
                setCurrentBannerIndex((prevIndex) => 
                    prevIndex === banners.length - 1 ? 0 : prevIndex + 1
                );
            }, 5000); // 5 seconds

            return () => clearInterval(interval);
        }
    }, [banners.length]);

    useEffect(() => {
        if((searchAdvanced || site?.id == 1684 || site?.id == 2146 || site?.id == 1803 || site?.id == 2177) && (site?.caracteristicas_home || site?.categoria_home || site?.mostrar_data_entrega)){
            GetInitialFilters()
        }
    }, [searchAdvanced]);

    useEffect(() => {
        if(allCitiesAux?.length == 1){
            onChangeCity(allCitiesAux[0]);
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Enter") {
            redirectToLink();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    const redirectToLink = () => {
        const element = document.getElementById('myLink');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const next = newFilter();
        if(next){
            if (filterPrice.min !== next.min || filterPrice.max !== next.max) {
                setFilterPrice(next);
            }

            if (value2[0] !== next.min || value2[1] !== next.max) {
                setValue2([next.min, next.max]);
            }
        }
    }, [allTransacao, transacaoActual]);

    const renderArchives = () => {
        if (banners.length > 0 && site?.id != 1235) {
            // Caso só tenha um banner
            if (banners.length === 1) {
            const banner = banners[0];
            const imageElement = (
                <Image
                    className={styles.banner_single}
                    alt="Banner"
                    title="Banner"
                    height={1200}
                    width={1920}
                    src={banner.url.replaceAll('"', "")}
                    priority
                />
            );

            return banner.message ? 
                    banner.url_link ? (
                        <Link key={"banner"} title={`Clique para ser direcionado ao conteúdo do banner`} href={banner.url_link} prefetch={false}>
                            {imageElement}
                            <div className={styles.title_banner}>
                                <h1>{banner.message.toUpperCase()}</h1>
                                <button className={styles.button_banner}>CONHEÇA</button>
                            </div>
                        </Link>
                    ) : (
                    <>
                        {imageElement}
                        <div className={styles.title_banner}>
                            <h1>{banner.message.toUpperCase()}</h1>
                            <button className={styles.button_banner}>CONHEÇA</button>
                        </div>
                    </>)
                : banner.url_link ? (
                    <Link key={"banner"} title={`Clique para ser direcionado ao conteúdo do banner`} href={banner.url_link} prefetch={false}>
                        {imageElement}
                    </Link>
                ) : (
                    imageElement
                );
            }

            // Caso tenha mais de um banner
            return (
            <div className={styles.banner_carousel}>
                {banners.map((banner: any, index: number) => {
                    const imageElement = (
                        <Image
                            key={index}
                            className={`${styles.banner_slide} ${
                                index === currentBannerIndex ? styles.banner_active : ""
                            }`}
                            alt={`Banner ${index}`}
                            height={1200}
                            width={1920}
                            src={banner.url.replaceAll('"', "")}
                            priority={index === 0}
                        />
                    );
                
                return banner.message ? 
                    banner.url_link ? (
                        <Link key={index} title={`Clique para ser direcionado ao conteúdo do banner`} href={banner.url_link} prefetch={false}>
                            {imageElement}
                            <div className={styles.title_banner}>
                                <h1>{banner.message.toUpperCase()}</h1>
                                <button className={styles.button_banner}>CONHEÇA</button>
                            </div>
                        </Link>
                    ) : (
                    <>
                        {imageElement}
                        <div className={styles.title_banner}>
                            <h1>{banner.message.toUpperCase()}</h1>
                            <button className={styles.button_banner}>CONHEÇA</button>
                        </div>
                    </>)
                : banner.url_link ? (
                    <Link key={index} title={`Clique para ser direcionado ao conteúdo do banner`} href={banner.url_link} prefetch={false}>
                        {imageElement}
                    </Link>
                ) : (
                    imageElement
                );
                })}
            </div>
            );
        }

        // Fallback para vídeo
        if ((isMobile || isMobile1) && site?.id == 1235) {
            return (
            <video
                autoPlay
                muted
                loop
                height="100%"
                width="100%"
                className={styles.video_render}
                src={site?.url_video.replace(".mp4", "_b.mp4")}
                playsInline
            >
                <track kind="captions" label="Legenda" src="legenda.vtt"></track>
            </video>
            );
        }
        return (
            <video
            autoPlay
            muted
            loop
            height="100%"
            width="100%"
            className={styles.video_render}
            src={site?.url_video}
            playsInline
            >
            <track kind="captions" label="Legenda" src="legenda.vtt"></track>
            </video>
        );
        };


    return (
        <div className={styles.container_adjust_text_header}>
            <div className={styles.banner_container}>
                {renderArchives()}
            </div>
            <div id="myLink" style={{position: 'absolute',bottom: 350}}></div>
            {/* toggle */}
            <div className={styles.search_advanced_toggle}>
                <button
                    className={searchAdvanced ? styles.advanced_button : styles.advanced_button_click}
                    onClick={(e) => {
                        setSearchAdvanced(!searchAdvanced)
                        redirectToLink()
                    }}
                    aria-expanded={searchAdvanced}
                    >
                    BUSCA SIMPLES
                </button>
                <button
                    className={searchAdvanced ? styles.advanced_button_click : styles.advanced_button}
                    onClick={(e) => {
                        setSearchAdvanced(!searchAdvanced)
                        redirectToLink()
                    }}
                    aria-expanded={searchAdvanced}
                    >
                   BUSCA AVANÇADA
                </button>
            </div>
            <div className={styles.search_section}>
                <span className={styles.adjust_text_header}>
                    {site?.frase_busca ?
                    site?.id == '2112' ?
                    <motion.h1
                        alt="Título"
                        className={styles.text_header}
                        style={{fontSize: '64px', margin: '0px'}}
                        dangerouslySetInnerHTML={{
                            __html: site?.frase_busca.toUpperCase(),
                        }}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            delay: 0.2,
                            duration: 1,
                            ease: "easeOut"
                        }}
                    ></motion.h1>
                    :
                    <motion.h1
                        alt="Título"
                            className={styles.text_header}
                        style={site?.id == 2102 ? {fontSize: 36} : site?.id == 1992 ? {fontSize: 38} : site?.id == 2165 || site?.id == 1630 ? {fontWeight: 500} : site?.id == 1730 ? {color: "#eacba6"} : site?.id == '2127' ? {margin: 0} : site?.id == 2126 ? {color: "#ab0303",fontSize: 40} : {}}
                        dangerouslySetInnerHTML={{
                            __html: site?.id === 2177
                                ? `<span style="font-weight:100;">Descubra o Melhor do </span><span style="font-weight:bold;">Litoral Catarinense</span><span style="font-weight:100;"> e da </span><span style="font-weight:bold;">Serra Gaúcha</span>.<br>
                                    <span style="font-weight:100;">Imóveis exclusivos em </span><span style="font-weight:bold;">Itapema, Gramado e Canela</span><span style="font-weight:100;"> com a </span><span style="font-weight:bold;">confiança da Imobiliária Régis da Silveira</span>.`
                                : site?.frase_busca,
                            }}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            delay: 0.2,
                            duration: 1,
                            ease: "easeOut"
                        }}
                    ></motion.h1>
                    : null}
                    {site?.frase_busca_2 ?
                    <motion.h2
                        alt="Subtitulo"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            delay: 0.4,
                            duration: 1,
                            ease: "easeOut"
                        }}
                    className={styles.text_header2} style={site?.id == 1992 ? {fontSize: 25} : site?.id == '2103' ? {fontSize: '24px', fontFamily: 'Roboto'} : site?.id == '2127' ? {fontSize: '26px'} : site?.id == '2348' ? {fontSize: '24px'} : {}}>
                        {site?.frase_busca_2}</motion.h2>
                    : null}
                </span>
               <div className={styles.search_form}>
                    {/* LINHA PRINCIPAL */}
                    <ul className={styles.formGrid} role="list">
                        {allTransacao?.length > 1 &&
                        <li className={styles.formItem} role="listitem">
                            <Select
                                inputId="transacao"
                                defaultValue={allTransacao[0]?.value}
                                options={allTransacao}
                                placeholder={allTransacao?.length > 0 ? allTransacao[0]?.value : "TRANSAÇÃO"}
                                noOptionsMessage={() => 'Processando'}
                                styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                value={transacaoActual}
                                onChange={onChangeTransacao}
                                instanceId={1}
                                isSearchable={false}
                            />
                        </li>}

                        <li className={styles.formItem} role="listitem">
                        <Select
                            styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                            options={allTypes}
                            isSearchable={false}
                            isMulti
                            placeholder="TIPO DO IMÓVEL"
                            value={typesActual}
                            onChange={onChangeTypes}
                        />
                        </li>

                        <li className={styles.formItem} role="listitem">
                            <Select
                                styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                options={allCitiesAux}
                                isSearchable
                                placeholder="CIDADE"
                                value={citiesActual}
                                onChange={onChangeCity}
                            />
                        </li>

                        <li className={styles.formItem} role="listitem">
                        <Select
                            styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                            options={allDistrict}
                            isSearchable
                            isMulti
                            placeholder="BAIRRO"
                            value={districtActual}
                            onChange={onChangeDistrict}
                        />
                        </li>

                        {/* Preço Mínimo */}
                        <li className={styles.formItem} style={{minWidth: "160px"}} role="listitem">
                            <input
                                id="precoMin"
                                type="number"
                                inputMode="numeric"
                                className={styles.search_input}
                                style={{ borderColor: cor_font, color: cor_font }}
                                placeholder="PREÇO MÍNIMO"
                                value={minPrice ? minPrice : ''}
                                onChange={onMinChange}
                                min={0}
                                step={transacaoActual?.value === 'Aluguel' ? 100 : 1000}
                            />
                        </li>

                        {/* Preço Máximo */}
                        <li className={styles.formItem} style={{minWidth: "160px"}} role="listitem">
                            <input
                                id="precoMax"
                                type="number"
                                inputMode="numeric"
                                className={styles.search_input}
                                style={{ borderColor: cor_font, color: cor_font }}
                                placeholder="PREÇO MÁXIMO"
                                value={maxPrice ? maxPrice : ''}
                                onChange={onMaxChange}
                                min={0}
                                step={transacaoActual?.value === 'Aluguel' ? 100 : 1000}
                            />
                        </li>

                        {/* input maior (2 colunas) */}
                        <li className={`${styles.formItem}`} style={{minWidth: "160px"}} role="listitem">
                            <input
                                className={styles.search_input}
                                type="text"
                                style={{borderColor: cor_font,color: cor_font}}
                                placeholder="BUSCA POR CÓDIGO"
                                value={codeActual}
                                onChange={onChangeCode}
                            />
                        </li>

                    {/* BUSCA AVANÇADA */}
                    {searchAdvanced && 
                        <>
                            <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                    options={allOptions}
                                    isSearchable={false}
                                    placeholder="BANHEIROS"
                                    value={banheirosActual}
                                    onChange={onChangeBanheiros}
                                />
                            </li>

                            <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                    options={allOptions}
                                    isSearchable={false}
                                    placeholder="DORMITÓRIOS"
                                    value={dormitoriosActual}
                                    onChange={onChangeDormitorios}
                                />
                            </li>

                            <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                    options={allOptions}
                                    isSearchable={false}
                                    placeholder="SUÍTES"
                                    value={suitesActual}
                                    onChange={onChangeSuites}
                                />
                            </li>

                            <li className={styles.formItem} role="listitem">
                                <Select
                                styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                options={allOptions}
                                isSearchable={false}
                                placeholder="VAGAS"
                                value={vagasActual}
                                onChange={onChangeVagas}
                                />
                            </li>

                            {site?.id == 2177 && (
                                <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                    options={listEstados}
                                    isSearchable
                                    placeholder="ESTADO"
                                    value={estadoActual}
                                    onChange={onChangeEstado}
                                />
                                </li>
                            )}

                            {site?.categoria_home && (
                                <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                    options={listCategory}
                                    isSearchable={false}
                                    placeholder="CATEGORIA"
                                    value={categoryActual}
                                    onChange={onChangeCategory}
                                />
                                </li>
                            )}

                            {site?.caracteristicas_home && (
                                <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                    options={listCaracteristicas}
                                    isSearchable={false}
                                    isMulti
                                    placeholder="CARACTERÍSTICAS"
                                    value={caractActual}
                                    onChange={onChangeCaracteristicas}
                                />
                                </li>
                            )}

                            { site?.exibir_empreendimento ?
                                <li className={styles.formItem} role="listitem">
                                    <Select
                                        options={allCompany}
                                        className={styles.select1}
                                        placeholder={site?.id == "1892" ? "RESIDENCIAIS E LOTEAMENTOS" : "CONDOMÍNIOS"}
                                        styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                        value={companyActual}
                                        inputValue={companyInputActual}
                                        noOptionsMessage={() =>
                                            allCompany?.length > 1 ? 'CONDOMÍNIO NÃO ENCONTRADO' : 'DIGITE O NOME DO CONDOMÍNIO'
                                        }
                                        instanceId={9}
                                        onChange={onChangeCompany}
                                        onInputChange={onInputChangeCompany}
                                    />
                                </li>
                            : null }

                            {site?.mostrar_data_entrega && (
                                <li className={styles.formItem} role="listitem">
                                <Select
                                    styles={Mocks.customSelectPropertiesStyles(cor_font, site?.cor5, cor_font)}
                                    options={listDatas}
                                    isSearchable={false}
                                    isMulti
                                    placeholder="DATA DE ENTREGA"
                                    value={dataEntregaActual}
                                    onChange={onChangeDataEntrega}
                                />
                                </li>
                            )}
                        </>}
                        {/* botão */}
                        <li className={`${styles.formItem}`} style={{minWidth: 100}} role="listitem">
                            <Link href={renderPath()}>
                                <button className={styles.search_button}>BUSCAR</button>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                menus={props?.menus}
            />
        </div>
    );
};

export default WelcomePieces;
